<template>
  <select :style="{ width: width }">
  </select>
</template>

<script>
  export default {
    name: 'donSelect',
    props: {
      options: Array,
      value: [String, Number, Boolean, Object],
      reload: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: ''
      }
    },
    mounted: function () {
      var vm = this
      $(this.$el)
        .val(this.value)
        // init select2
        .select2({ data: this.options,escapeMarkup: function (m) {
        return m;
    } })
        // emit event on change.
        .on('change', function () {
          //console.log(vm.idel)
          vm.$emit('input', this.value)
        })
    },
    watch: {
      value: function (value) {
        // update value
        $(this.$el).val(value).trigger("change")
      },
      options: function (options) {
        if (this.reload) {
          $(this.$el).html('')
          $(this.$el).select2({ data: options,escapeMarkup: function (m) {
        return m;
    } }).val(this.value).trigger("change")
        }
      }
    },
    destroyed: function () {
      $(this.$el).off().select2('destroy')
    }
  }
</script>



// WEBPACK FOOTER //
// src/componentes/global/don.select.vue